import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'docTimeRange'
})

export class DocTimeRangePipe implements PipeTransform {
    private timeFormat = 'HH:mm';
    transform(timestamp: string, duration?: number): string {
        return moment(timestamp).format(this.timeFormat) + ' - ' + moment(timestamp).add(duration, 'minutes').format(this.timeFormat);
    }
}